"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
import ContactService from "../accounts_payable/contact_service";
export default {
  index: function() {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/contacts/",
      type: "get",
      contentType: "application/json"
    }));
  },
  update: function(contactId, contact, withoutDetails) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/contacts/" + contactId,
      type: "put",
      data: JSON.stringify({ contact }),
      contentType: "application/json"
    }), "", withoutDetails).then(function(data) {
      DataStoreService.updateStores(data);
      ContactService.contactService.updateContact(contact);
    });
  },
  create: function(contact, withoutDetails) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/contacts",
      type: "post",
      data: JSON.stringify({ contact }),
      contentType: "application/json"
    }), "", withoutDetails).then(function(data) {
      DataStoreService.updateStores(data);
      contact.id = data.contact.id;
      return ContactService.contactService.updateContact(contact);
    });
  },
  destroy: function(contact) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/contacts/" + contact.id,
      type: "delete",
      contentType: "application/json"
    })).then(function(data) {
      DataStoreService.updateStores(data);
      ContactService.contactService.destroyContact(contact);
    });
  },
  sendAppInvite: function(contact, success) {
    return ApiService.addErrorHandler($.ajax({
      url: "/hubtran/invites/request_app_invite",
      type: "post",
      data: JSON.stringify({ email_address: contact.email, carrier_id: contact.carrier_id }),
      contentType: "application/json",
      success: function(data) {
        DataStoreService.updateStores(data);
        if (success) {
          success(data);
        }
      }
    }));
  }
};
